import React from 'react';

import { useSOClientDetailLang } from './hooks';

import makeClasses from './SOClientDetail.style';

interface Props {
  clientName: string;
}

export function SOClientDetail({ clientName }: Props) {
  const classes = makeClasses();
  const lang = useSOClientDetailLang();

  return (
    <div className={classes.root}>
      <p className={classes.sectionLabel}>{lang.sectionTitle}</p>
      <p className={classes.clientName}>{clientName}</p>
    </div>
  );
}
